import * as React from 'react';
export const IcOfferCoupon = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.57 21a1.7 1.7 0 012.43-.82 1.71 1.71 0 002.54-1.84 1.71 1.71 0 011.51-2.08 1.7 1.7 0 001-3 1.71 1.71 0 010-2.56 1.7 1.7 0 00-1-3 1.71 1.71 0 01-1.51-2.08A1.71 1.71 0 0016 3.82 1.7 1.7 0 0113.57 3a1.71 1.71 0 00-3.14 0A1.7 1.7 0 018 3.82a1.71 1.71 0 00-2.54 1.84A1.71 1.71 0 014 7.74a1.7 1.7 0 00-1 3 1.71 1.71 0 010 2.56 1.7 1.7 0 001 3 1.71 1.71 0 011.51 2.08A1.71 1.71 0 008 20.18a1.701 1.701 0 012.43.79 1.71 1.71 0 003.14.03zM9.25 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.5 8a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501zm1-6.29l-6 6a.998.998 0 01-1.42 0 .999.999 0 010-1.42l6-6a1.004 1.004 0 011.42 1.42z'
      fill='currentColor'
    />
  </svg>
);
